import { useContext, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

import { HeaderContext } from '../../LayoutWithLeftSidebar/HeaderContext'

import { useDocuments } from '../DocumentUpload/hooks'

import { DocumentFilters } from './DocumentFilters'
import { DocumentGroups } from './DocumentGroups'
import { DocumentsHeader } from './DocumentsHeader'

import './Documents.scss'

export const Documents = () => {
  const { documentsResponse, groupedDocuments, isLoading, accountHasZDRPolicy } = useDocuments()

  const { portalRef } = useContext(HeaderContext)

  const [headerContainer, setHeaderContainer] = useState<HTMLElement | null>(null)

  useEffect(() => {
    if (portalRef && portalRef.current) {
      setHeaderContainer(portalRef.current)
    }
  }, [portalRef])

  return (
    <>
      {headerContainer ? createPortal(<DocumentsHeader />, headerContainer) : null}
      <div className='d-flex flex-column zocks-gap-1.5'>
        <div className='d-flex flex-column'>
          <h3>Documents</h3>
          <span className='paragraph-medium zocks-text-gray-700'>
            {documentsResponse?.page.totalElements ?? 0} {documentsResponse?.page.totalElements === 1 ? 'document' : 'documents'}
          </span>
        </div>
        <DocumentFilters />
        <DocumentGroups
          isLoading={isLoading}
          groups={groupedDocuments}
          totalElements={documentsResponse?.page.totalElements ?? 0}
          accountHasZDRPolicy={accountHasZDRPolicy}
        />
      </div>
    </>
  )
}
